(function () {
  'use strict';

  if (window.location.pathname.toLowerCase().indexOf('/collections/bathroom-vanities') === -1) return;

  // ─── CSS ─────────────────────────────────────────────────────────────────────
  var style = document.createElement('style');
  style.textContent = [
    '.sz-parent { display:block !important; width:100%; list-style:none; margin:0; }',
    '.sz-toggle {',
    '  display:flex; align-items:center; justify-content:space-between;',
    '  width:100%; background:none; border:none; padding:0.7rem 0;',
    '  cursor:pointer; font-weight:600; font-size:inherit;',
    '  font-family:inherit; color:inherit; text-align:left;',
    '}',
    '.sz-children { list-style:none; margin:0; padding-left:1.2rem; }',
    '.sz-children.is-closed { display:none !important; }',
    '.sz-children.is-open   { display:block !important; }',
    '.sz-children .facets__label {',
    '  display:flex !important; align-items:flex-start !important;',
    '  gap:0.6rem !important; width:100% !important;',
    '}',
    '.sz-children .facets__label input[type="checkbox"] {',
    '  flex-shrink:0 !important; margin-top:0.2rem !important;',
    '}'
  ].join('\n');
  document.head.appendChild(style);

  // ─── Toggle — bound once in capture phase ────────────────────────────────────
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.sz-toggle');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var wrap = btn.nextElementSibling;
    if (!wrap || !wrap.classList.contains('sz-children')) return;
    var isOpen = wrap.classList.contains('is-open');
    wrap.classList.toggle('is-closed', isOpen);
    wrap.classList.toggle('is-open', !isOpen);
    var arrow = btn.querySelector('.sz-arrow');
    if (arrow) arrow.style.transform = isOpen ? 'rotate(0deg)' : 'rotate(180deg)';
  }, true);

  // ─── Helpers ─────────────────────────────────────────────────────────────────

  function getWidth(text) {
    var m = text.trim().match(/^(\d+)\s*"/);
    return m ? m[1] + '"' : null;
  }

  function cleanText(raw) {
    return raw.replace(/\(\d+\s*products?\)/gi, '').replace(/\(\d+\)/g, '').replace(/\s+/g, ' ').trim();
  }

  // ─── Group ───────────────────────────────────────────────────────────────────

  function groupFilter(filterEl) {
    if (filterEl.dataset.szDone === '1') return;

    // Find the list container — the <ul> directly inside the filter
    var listContainer = filterEl.querySelector('ul');
    if (!listContainer) return;

    // Get all real checkbox items
    var allItems = Array.from(listContainer.querySelectorAll(':scope > li.list-menu__item'));
    if (!allItems.length) return;

    // Build groups
    var groups = {}, order = [];
    allItems.forEach(function (li) {
      var lbl = li.querySelector('label');
      if (!lbl) return;
      var w = getWidth(cleanText(lbl.textContent));
      if (!w) return;
      if (!groups[w]) { groups[w] = []; order.push(w); }
      groups[w].push(li);
    });
    if (!order.length) return;

    order.sort(function (a, b) { return parseInt(a) - parseInt(b); });

    // Hide show-more-button
    var showMore = filterEl.querySelector('show-more-button');
    if (showMore) showMore.style.display = 'none';

    // Remove hidden class from all items upfront
    allItems.forEach(function (li) {
      li.classList.remove('hidden', 'show-more-item');
    });

    // Re-insert all in sorted order
    order.forEach(function (width) {
      var children = groups[width];

      if (children.length === 1) {
        // Flat — just re-append in sorted position
        listContainer.appendChild(children[0]);
        return;
      }

      // Build parent toggle
      var parent = document.createElement('li');
      parent.className = 'sz-parent';

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'sz-toggle';
      btn.innerHTML =
        '<span>' + width + ' - Wide</span>' +
        '<span class="sz-arrow" style="display:inline-block;transition:transform 0.2s;">&#9662;</span>';

      var wrap = document.createElement('ul');
      wrap.className = 'sz-children is-closed';

      // Move children into wrap
      children.forEach(function (li) { wrap.appendChild(li); });

      parent.appendChild(btn);
      parent.appendChild(wrap);
      listContainer.appendChild(parent);
    });

    filterEl.dataset.szDone = '1';
  }

  // ─── Poll until items exist, then group ──────────────────────────────────────
  // Dawn renders filters via AJAX after DOMContentLoaded, so we cannot rely
  // on any single event. We poll every 200ms until items appear, then group.
  // After grouping, a MutationObserver handles AJAX re-renders.

  var maxAttempts = 40; // 40 × 200ms = 8 seconds max
  var attempts = 0;
  var observer = null;

  function tryGroup() {
    var filters = document.querySelectorAll('.js-filter[id*=".custom.size-"]');
    var hasItems = false;

    filters.forEach(function (el) {
      var ul = el.querySelector('ul');
      var items = ul ? ul.querySelectorAll(':scope > li.list-menu__item') : [];
      if (items.length > 0) hasItems = true;
      groupFilter(el);
    });

    if (hasItems) {
      // Items found and grouped — switch to MutationObserver for re-renders
      startObserver();
      return;
    }

    // No items yet — keep polling
    attempts++;
    if (attempts < maxAttempts) {
      setTimeout(tryGroup, 200);
    }
  }

  function startObserver() {
    if (observer) return;

    var targets = [
      document.getElementById('FacetFiltersForm'),
      document.getElementById('FacetFiltersFormMobile')
    ].filter(Boolean);

    if (!targets.length) return;

    observer = new MutationObserver(function (mutations) {
      var external = mutations.some(function (m) {
        return Array.from(m.addedNodes).some(function (n) {
          return n.nodeType === 1 &&
                 !n.classList.contains('sz-parent') &&
                 !n.classList.contains('sz-children');
        });
      });
      if (!external) return;

      observer.disconnect();
      observer = null;

      document.querySelectorAll('.js-filter[id*=".custom.size-"]').forEach(function (el) {
        delete el.dataset.szDone;
      });

      // Small delay so Dawn finishes its full re-render before we re-group
      setTimeout(function () {
        attempts = 0;
        tryGroup();
      }, 100);
    });

    targets.forEach(function (t) {
      observer.observe(t, { childList: true, subtree: true });
    });
  }

  // Start polling immediately — don't wait for DOMContentLoaded
  tryGroup();

})();